module.exports = __webpack_public_path__ + "img/void-img.b2199640.png";